"use strict";

exports.__esModule = true;
exports.default = getVariation;
function getVariation(placement) {
  return placement.split('-')[1];
}